import {
  MGMT_OUTCOME_LIST, MGMT_OUTCOME_LIST_SUCCESS, MGMT_OUTCOME_LIST_ERROR,
  MGMT_OUTCOME_PAGE_SET, MGMT_OUTCOME_ADD, MGMT_OUTCOME_ADD_SUCCESS,
  MGMT_OUTCOME_ADD_ERROR, MGMT_OUTCOME_ADD_CHANGE,
  MGMT_OUTCOME_DETAIL, MGMT_OUTCOME_DETAIL_SUCCESS, MGMT_OUTCOME_DETAIL_ERROR,
  MGMT_OUTCOME_UPDATE, MGMT_OUTCOME_UPDATE_SUCCESS, MGMT_OUTCOME_UPDATE_ERROR,
} from '../../actions';

const INIT_STATE = {
  loading: true,
  list: { header: { name: 'code', order: 'sorted-asc' }, page: { current: 1, rows: 1000 }, data: [], total_pages: 1 },
  detail: { loading: false, data: null },
  add: { data: { new: { description: '', code: '', id_objective: '' } }, loading: false, message: '' },
  edit: { update: { loading: false, response: '', message: '' } },
  error: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case MGMT_OUTCOME_LIST: return { ...state, loading: true };
    case MGMT_OUTCOME_LIST_SUCCESS: return { ...state, loading: false, list: { ...state.list, ...action.payload } };
    case MGMT_OUTCOME_LIST_ERROR: return { ...state, loading: false, error: true };
    case MGMT_OUTCOME_PAGE_SET: return { ...state, list: { ...state.list, page: { ...state.list.page, ...action.payload } } };
    case MGMT_OUTCOME_ADD_CHANGE: return { ...state, add: { ...state.add, data: { ...state.add.data, new: { ...state.add.data.new, ...action.payload } } } };
    case MGMT_OUTCOME_ADD: return { ...state, add: { ...state.add, loading: true } };
    case MGMT_OUTCOME_ADD_SUCCESS: return { ...state, add: { ...state.add, loading: false, message: action.payload.message, data: { new: { description: '', code: '', id_objective: '' } } } };
    case MGMT_OUTCOME_ADD_ERROR: return { ...state, add: { ...state.add, loading: false, message: action.payload.message } };
    case MGMT_OUTCOME_DETAIL: return { ...state, detail: { ...state.detail, loading: true } };
    case MGMT_OUTCOME_DETAIL_SUCCESS: return { ...state, detail: { loading: false, data: action.payload } };
    case MGMT_OUTCOME_DETAIL_ERROR: return { ...state, detail: { loading: false, data: null } };
    case MGMT_OUTCOME_UPDATE: return { ...state, edit: { ...state.edit, update: { loading: true, response: '', message: '' } } };
    case MGMT_OUTCOME_UPDATE_SUCCESS: return { ...state, edit: { ...state.edit, update: { loading: false, response: 'success', message: action.payload } } };
    case MGMT_OUTCOME_UPDATE_ERROR: return { ...state, edit: { ...state.edit, update: { loading: false, response: 'error', message: action.payload } } };
    default: return { ...state };
  }
};
